function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _require = require('flatted'),
    stringify = _require.stringify;

var isObject = function isObject(value) {
  return _typeof(value) === 'object' && value !== null && (value.length === undefined || value.length === null);
};

var isNotObject = function isNotObject(value) {
  return !isObject(value);
};

var isBoolean = function isBoolean(str) {
  return /^true/.test(str) || /^false/.test(str);
};

var isEmpty = function isEmpty(value) {
  return value === null || value === undefined;
};

var isString = function isString(key) {
  return key && typeof key === 'string';
};

var isStrPath = function isStrPath(key) {
  if (!isString(key)) throw new Error("Key ".concat(key, " should be string"));
  return isString(key) && key.includes('.');
};

var isArray = function isArray(value) {
  return Array.isArray(value);
};

var isEqual = function isEqual(target, source) {
  return stringify(target) === stringify(source);
};

var canMerge = function canMerge(value) {
  return isObject(value) || isArray(value);
};

var prettyPrint = function prettyPrint(obj) {
  return JSON.stringify(obj, null, 2);
};

var chdirTestApp = function chdirTestApp() {
  try {
    return process.chdir('test/test_app');
  } catch (e) {
    return null;
  }
};

var chdirCwd = function chdirCwd() {
  return process.chdir(process.cwd());
};

var resetEnv = function resetEnv() {
  process.env = {};
};

var ensureTrailingSlash = function ensureTrailingSlash(path) {
  return path.endsWith('/') ? path : "".concat(path, "/");
};

module.exports = {
  chdirTestApp: chdirTestApp,
  chdirCwd: chdirCwd,
  ensureTrailingSlash: ensureTrailingSlash,
  isObject: isObject,
  isNotObject: isNotObject,
  isBoolean: isBoolean,
  isArray: isArray,
  isEqual: isEqual,
  isEmpty: isEmpty,
  isStrPath: isStrPath,
  canMerge: canMerge,
  prettyPrint: prettyPrint,
  resetEnv: resetEnv
};